export { default as PaymentsPage } from "./PaymentsPage";
